import { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react'

const ThaiId = (props) => {
  let { open, onClose, action, data, designContext } = props
  const [isProcess, setIsProcess] = useState(true)
  const [message, setMessage] = useState('')

  const connectDesktopApp = async () => {
    console.log('connectDesktopApp')
  }

  useEffect(async () => {
    if (open) {
      connectDesktopApp()
    }
  }, [open])

  const reConnect = () => {
    console.log('reConnect')
  }

  return (
    <Modal show={open} size="md">
      <Modal.Header
        onHide={onClose}
        style={{
          backgroundColor: '#fff',
        }}
      >
        <h5
          className="mb-0"
          style={{
            color: '#000',
          }}
        >
          บัตรประชาชน
        </h5>
      </Modal.Header>
      <Modal.Body className="p-3">
        <Form.Label>
          {isProcess
            ? 'รอสักครู่ กำลังอ่านข้อมูลจากบัตรประชาชน...'
            : 'อ่านข้อมูลจากบัตรประชาชนเสร็จสิ้น'}
        </Form.Label>
        <Form.Control as="textarea" rows="6" readOnly value={message} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          className="my-0 w-100"
          onClick={reConnect}
        >
          <FeatherIcon icon="refresh-cw" size="16" className="mr-1" />
          แสกนอีกครั้ง
        </Button>
        <Button
          variant="outline-secondary"
          className="my-2 w-100"
          onClick={onClose}
        >
          <FeatherIcon icon="x" size="16" className="mr-1" />
          ปิด
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ThaiId
